<template>

    <div class="lfg">

        <div class="header">
            <div class="side">
                <button @click="back">
                    <img src="/img/login/google/chevron-left.svg">
                    <span v-show="isDesktop">{{ $t('global_back') }}</span>
                </button>
            </div>
            <div class="title-header">
                <img src="/img/login/google/Logo.svg" @click="goLanding()" class="logo">
            </div>
            <div class="side"></div>
        </div>

        <div class="background">

            <div class="bloc">

                <div class="steps">

                    <div class="red-line" v-show="!isDesktop">
                        <div class="alabasta">
                            <div class="line" :class="{'line-pending': isAppPass, 'line-completed': isLogin}"></div>
                            <div class="line" :class="{'line-pending': isLogin}"></div>
                        </div>
                        <div class="skypiea">
                            <div class="isle">
                                <img :src="circle1" class="circle">
                                <span :class="{'active': isDoubleAuth, 'validated': !isDoubleAuth}">{{
                                        $t('google_flow_1step')
                                    }}</span>
                            </div>
                            <div class="isle">
                                <img :src="circle2" class="circle">
                                <span :class="{'active': isAppPass, 'validated': isLogin}">{{
                                        $t('google_flow_2step')
                                    }}</span>
                            </div>
                            <div class="isle">
                                <img :src="circle3" class="circle">
                                <span :class="{'active': isLogin}">{{ $t('google_flow_3step') }}</span>
                            </div>
                        </div>

                    </div>
                    <div v-show="isDesktop" class="tabs">
                        <div class="tab" :class="{'tab-pending': isDoubleAuth, 'tab-completed': !isDoubleAuth}"
                             @click="clickTab(steps.DOUBLE_AUTH)">
                            <img src="/img/login/google/check.svg" v-show="!isDoubleAuth">
                            <span>{{ $t('web_2FA_authentification') }}</span>
                        </div>
                        <div class="tab"
                             :class="{'tab-pending': isAppPass, 'tab-completed': isLogin, 'next-tab': isDoubleAuth}"
                             @click="clickTab(steps.APP_PASS)">
                            <img src="/img/login/google/check.svg" v-show="isLogin">
                            <span>{{ $t('web_app_password_creation') }}</span>
                        </div>
                        <div class="tab" :class="{'tab-pending': isLogin, 'next-tab': isAppPass}">
                            <span>{{ $t('login_email_web_header') }}</span>
                        </div>
                    </div>

                </div>

                <div class="content">

                    <p class="title" v-show="!isDesktop">{{ stepTitle }}</p>

                    <div class="article">

                        <template v-if="isDoubleAuth">

                            <phase :number="1"
                                   :title="$t('web_google_connexion')"
                                   :subtitle="$t('web_google_connexion_subtitle')"
                                   :image="phaseImage"></phase>

                            <phase :number="2"
                                   :title="$t('web_google_connexion_step2')"
                                   :subtitle="$t('web_google_connexion_step2_subtitle')"
                                   :subtitleCta="true"
                                    @action="goStep(steps.APP_PASS)"></phase>

                        </template>

                        <template v-if="isAppPass">

                            <phase :number="1"
                                   :title="$t('web_reconnect_google')"></phase>
                            <phase :number="2"
                                   :title="$t('web_step2')"></phase>
                            <phase :number="3"
                                   :title="$t('web_copy_app_password')"
                                   :subtitle="$t('web_copy_app_password_subtitle')"></phase>

                        </template>

                        <template v-if="isLogin">

                            <markdown class="subtitle" :text="$tc('web_indicate_app_password', 0, {email})"
                                      :color="'#32A3EB'"></markdown>

                            <label class="label" for="app-pass"
                                   :class="{'error': error, 'little-label': inputValue.length}">
                                <span v-show="inputValue.length">{{
                                        $t('login_application_password_placeholder')
                                    }}</span>
                                <the-mask v-model="inputValue"
                                          :mask="['XXXX XXXX XXXX XXXX']"
                                          type="text"
                                          class="input"
                                          :class="{'big-input': !inputValue.length}"
                                          :placeholder="$t('login_application_password_placeholder')"
                                          v-on:keyup.enter="ctaActionLogin"/>
                            </label>

                            <div class="error-message" v-show="error">{{ errorMessage }}</div>


                        </template>

                    </div>

                </div>

                <div class="footer">

                    <button @click="ctaActionDoubleAuth" v-if="isDoubleAuth">
                        <span>{{ ctaTextDoubleAuth }}</span>
                        <img :src="ctaIconDoubleAuth">
                    </button>

                    <div v-if="isAppPass" class="multiple">
                        <button class="back-white" @click="goStep(steps.DOUBLE_AUTH)" v-show="!isDesktop">
                            <img src="/img/icons/arrow-left-blue.svg">
                            <span>{{ $t('global_back') }}</span>
                        </button>
                        <div class="spacer" v-show="!isDesktop"></div>
                        <button class="next" @click="ctaActionAppPass">
                            <span>{{ ctaTextAppPass }}</span>
                            <img :src="ctaIconAppPass">
                        </button>
                    </div>

                    <button @click="ctaActionLogin" v-if="isLogin" class="cta-login">
                        <lottie-loader v-if="loading" :size="24"></lottie-loader>
                        <span v-else>{{ $t('global_sign_in') }}</span>
                    </button>

                </div>

            </div>
        </div>

    </div>

</template>

<script>

import {TheMask} from 'vue-the-mask'
import Vuex from 'vuex'

import ENUM from '../assets/ENUM'

import Login from '../modules/login'
import Tag from '../modules/tag'
import UserFlow from '../modules/userFlow'

import LottieLoader from '../components/lottie/LottieLoader'
import Markdown from '../components/Markdown'
import Phase from '../components/loginFlow/google/Phase'

import SessionStorage from '../helpers/sessionStorage'


export default {

    name: 'login-flow-google',

    components: {LottieLoader, Markdown, Phase, TheMask},

    watch: {
        inputValue(value) {
            if (value.length === 16) {
                this.errorCountCharacters = false
            }
        }
    },

    computed: {

        ...Vuex.mapGetters(['lang']),

        circle1() {
            return this.isDoubleAuth ? '/img/login/google/arrow.svg' : '/img/login/google/check.svg'
        },

        circle2() {
            if (this.isDoubleAuth) {
                return '/img/login/google/circle-grey.svg'
            } else if (this.isAppPass) {
                return '/img/login/google/arrow.svg'
            } else {
                return '/img/login/google/check.svg'
            }
        },

        circle3() {
            if (this.isLogin) {
                return '/img/login/google/arrow.svg'
            } else {
                return '/img/login/google/circle-grey.svg'
            }
        },

        stepTitle() {
            switch (this.step) {
                case this.steps.DOUBLE_AUTH:
                    return this.$t('web_2FA_authentification')
                case this.steps.APP_PASS:
                    return this.$t('web_app_password_creation')
                case this.steps.LOGIN:
                    return this.$t('login_email_web_header')
            }
        },

        ctaTextDoubleAuth() {
            return this.isRedirectionStep1Done ? this.$t('global_continue') : this.$t('web_open_google')
        },

        ctaTextAppPass() {
            return this.isRedirectionStep2Done ? this.$t('web_google_code') : this.$t('global_continue')
        },

        ctaIconDoubleAuth() {
            return this.isRedirectionStep1Done ? '/img/icons/arrow-right-white.svg' : this.externalLinkImg
        },

        ctaIconAppPass() {
            return this.isRedirectionStep2Done ? '/img/icons/arrow-right-white.svg' : this.externalLinkImg
        },

        externalLinkImg() {
            return this.lang === 'ar-sa' ? '/img/icons/external-link-rotated.svg' : '/img/icons/external-link.svg'
        },

        isDoubleAuth() {
            return this.step === this.steps.DOUBLE_AUTH
        },

        isAppPass() {
            return this.step === this.steps.APP_PASS
        },

        isLogin() {
            return this.step === this.steps.LOGIN
        },
        error() {
            return this.errorCountCharacters || this.errorConnection
        },
        errorMessage() {
            return this.errorCountCharacters ? this.$t('google_flow_error') : this.$t('login_error_invalid_email_password')
        },
        phaseImage() {
            return this.isDesktop ? '/img/login/google/browser.svg' : '/img/login/google/phone.svg'
        }

    },

    data() {
        return {
            step: '',
            isRedirectionStep1Done: false,
            isRedirectionStep2Done: false,
            steps: ENUM.LOGIN_FLOW_GOOGLE.STEPS,
            actions: ENUM.LOGIN_FLOW_GOOGLE.ACTIONS,
            inputValue: '',
            errorConnection: false,
            errorCountCharacters: false,
            loading: false,
            email: false,
            provider: 'google'
        }
    },

    created() {
        this.email = SessionStorage.getItem('email')
        if (!this.email) {
            this.$router.push({path: '/login/email'})
        }
    },

    mounted() {
        this.goStep(this.steps.DOUBLE_AUTH)
    },

    methods: {

        goStep(step) {
            if (Object.values(this.steps).includes(step) && step !== this.step) {

                switch (step) {
                    case this.steps.DOUBLE_AUTH:
                        this.isRedirectionStep1Done = false
                        UserFlow.setPage(this, 'web_connexion_flow_step1')
                        break
                    case this.steps.APP_PASS:
                        this.isRedirectionStep2Done = false
                        UserFlow.setPage(this, 'web_connexion_flow_step2')
                        break
                    case this.steps.LOGIN:
                        UserFlow.setPage(this, 'web_connexion_flow_step3')
                        break
                }

                this.step = step
            }
        },

        ctaActionDoubleAuth() {
            if (this.isRedirectionStep1Done) {
                Tag.clickAll(this, 'web_connexion_flow_gmail_open', this.provider)
                this.goStep(this.steps.APP_PASS)
            } else {
                Tag.clickAll(this, 'web_connexion_flow_gmail_open', this.provider)
                window.open('https://myaccount.google.com/signinoptions/twosv?rapt=AEjHL4Oc5FBB3H8EuuXq55xEXegJI2xK7-HEI_sUFA2j1x326XgTcFvzymhKgp3gnqE35TCHCGwiOjb1wg5SIIRg4E3Yry7L_CEknQyTI21OezYosLTP2WE', '_blank', 'rel="noopener,noreferrer,nofollow"')
                this.isRedirectionStep1Done = true
            }
        },

        ctaActionAppPass() {
            if (this.isRedirectionStep2Done) {
                Tag.clickAll(this, 'web_connexion_flow_gmail_continue_code', this.provider)
                this.goStep(this.steps.LOGIN)
            } else {
                Tag.clickAll(this, 'web_connexion_flow_gmail_click2FA', this.provider)
                window.open('https://myaccount.google.com/apppasswords?pli=1&rapt=AEjHL4NMcK7CllOndS_ozPBU9DxkPzQgyA5sy4LegTQQcVtG2QZF6javNNWVUFPO3j-YNOBKCewrnSacQjUelvUP7V_ib78YT2s_-0gGLLAsk_dcBQ3Zoeg', '_blank', 'rel="noopener,noreferrer,nofollow"')
                this.isRedirectionStep2Done = true
            }
        },

        back() {
            switch (this.step) {
                case this.steps.DOUBLE_AUTH:
                    this.$router.go(-1)
                    break
                case this.steps.APP_PASS:
                    this.goStep(this.steps.DOUBLE_AUTH)
                    break
                case this.steps.LOGIN:
                    this.goStep(this.steps.APP_PASS)
                    break
            }
        },

        ctaActionLogin() {
            if (this.inputValue.length === 16 && !this.loading) {
                this.errorCountCharacters = false
                this.loading = true
                Tag.clickAll(this, 'web_connexion_flow_gmail_application_password', this.provider)
                Login.connect(this, this.email, this.inputValue, this.provider)
                    .catch(() => {
                        this.errorConnection = true
                        this.loading = false
                    })
            } else {
                this.errorCountCharacters = true
                // Keep the loading state unchanged (user using Enter key)
                // this.loading = false
            }
        },

        goLanding() {
            this.$router.push({path: '/'})
        },

        clickTab(step) {
            switch (step) {
                case this.steps.DOUBLE_AUTH:
                    if (!this.isDoubleAuth) {
                        this.goStep(this.steps.DOUBLE_AUTH)
                    }
                    break
                case this.steps.APP_PASS:
                    if (this.isLogin) {
                        this.goStep(this.steps.APP_PASS)
                    }
                    break
            }
        }

    }
}
</script>

<style lang="scss" scoped>


.lfg {
    display: flex;
    flex-direction: column;

    .header {
        padding: 16px 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.12);
        backdrop-filter: blur(10px);
        @media screen and (min-width: $above-tablet-length) {
            padding: 24px 32px;
        }

        .side {
            min-width: 24px;

            @media screen and (min-width: $above-tablet-length) {
                flex: 1;
            }

            &:lang(ar-sa) {
                transform: rotate(180deg);
            }

            button {
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: $white;
                font-size: 17px;
                font-weight: 600;
                line-height: 24px;
                color: $aquamarine;

                &:lang(ar-sa) {
                    flex-direction: row-reverse;
                }

                > img {
                    @media screen and (min-width: $above-tablet-length) {
                        margin-right: 4px;
                    }
                }
            }
        }

        .title-header {
            flex: 1;
            display: flex;
            justify-content: center;
            cursor: pointer;


            .logo {
                height: 16px;
                @media screen and (min-width: $above-tablet-length) {
                    height: 24px;
                }
            }
        }
    }

    .background {
        @media screen and (min-width: $above-tablet-length) {
            background-color: #E0F1FC;
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 1;
        }

        .bloc {
            @media screen and (min-width: $above-tablet-length) {
                background-color: $white;
                max-width: 720px;
                border-radius: 32px;
                overflow: hidden;
            }

            .steps {
                padding: 16px;

                @media screen and (min-width: $above-tablet-length) {
                    padding: 0
                }

                .red-line {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    position: relative;

                    .skypiea {
                        position: absolute;
                        left: 0;
                        right: 0;
                        top: 0;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-between;


                        .isle {
                            display: flex;
                            flex-direction: column;
                            align-items: center;

                            .circle {
                                width: 24px;
                                object-fit: contain;
                                z-index: 1;
                            }

                            .active {
                                font-weight: 600;
                            }

                            .validated {
                                color: $forest;
                            }
                        }
                    }

                    .alabasta {
                        display: flex;
                        flex-direction: row;
                        width: 100%;
                        padding: 10px 30px 0;

                        .line {
                            width: 100%;
                            height: 2px;
                            background-color: $neutralsPlatinum;
                            margin: 0 -1px;
                        }

                        .line-pending {
                            //full compatibility
                            background: rgb(94, 167, 116);
                            background: -moz-linear-gradient(90deg, rgba(94, 167, 116, 1) 20%, rgba(50, 163, 235, 1) 80%);
                            background: -webkit-linear-gradient(90deg, rgba(94, 167, 116, 1) 20%, rgba(50, 163, 235, 1) 80%);
                            background: linear-gradient(90deg, rgba(94, 167, 116, 1) 20%, rgba(50, 163, 235, 1) 80%);
                            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#5ea774", endColorstr="#32a3eb", GradientType=1);
                        }

                        .line-completed {
                            background-color: $forest;
                        }
                    }
                }

                .step-name {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    margin-top: 5px;
                    color: $neutralsMoon;
                    font-size: 15px;
                    font-weight: 400;
                }

                .tabs {
                    display: flex;
                    flex-direction: row;
                    font-size: 17px;
                    font-weight: 400;
                    line-height: 24px;
                    color: $neutralsMoon;


                    .tab {
                        padding: 16px;
                        flex: 1;
                        background-color: $timberwolf;
                        display: flex;
                        align-items: center;

                        > img {
                            width: 20px;
                            object-fit: contain;
                            margin-right: 12px;

                            &:lang(ar-sa) {
                                margin: 0 0 0 12px;
                            }
                        }

                        > span {
                            flex: 1;
                        }
                    }

                    .tab-pending {
                        color: $charcoal;
                        font-weight: 500;
                        background-color: $white;
                    }

                    .tab-completed {
                        color: $forest;
                        background-color: $white;
                        text-align: start;
                        cursor: pointer;
                    }

                    .next-tab {
                        text-align: center;
                        border-bottom-left-radius: 24px;

                        &:lang(ar-sa) {
                            border-bottom-right-radius: 24px;
                            border-bottom-left-radius: 0;
                        }
                    }
                }

            }

        }
    }

    .content {
        margin-top: 32px;
        padding: 0 16px 100px;
        display: flex;
        flex-direction: column;
        @media screen and (min-width: $above-tablet-length) {
            padding: 0 80px;
        }

        .article {
            text-align: start;
        }

        .title {
            text-align: start;
            color: $charcoal;
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 8px;
        }
    }
}


.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 8px 16px;
    box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.12);
    background-color: $white;

    @media screen and (min-width: $above-tablet-length) {
        position: relative;
        padding: 24px 80px 32px;
        box-shadow: none;
    }

    .multiple {
        display: flex;
        flex-direction: row;
        align-items: center;

        .spacer {
            width: 8px;
        }
    }

    button {
        font-family: proxima-nova;
        padding: 16px;
        background: $midnight;
        color: $white;
        border-radius: 32px;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        font-size: 17px;
        font-weight: 600;
        line-height: 24px;

        img {
            margin-left: 8px;

            &:lang(ar-sa) {
                margin-left: 0;
                margin-right: 8px;
                transform: rotate(180deg);
            }
        }

        &.back-white {
            background-color: $white;
            border: 4px solid $neutralsPlatinum;
            padding: 12px;
            color: $charcoal;

            & img {
                margin: 0 8px 0 0;

                &:lang(ar-sa) {
                    margin: 0 0 0 8px;
                    transform: rotate(180deg);
                }
            }
        }

    }

    .cta-login {
        background-color: $aquamarine;
    }
}

.subtitle {
    margin-top: 8px;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    @media screen and (min-width: $above-tablet-length) {
        font-size: 20px;
        font-weight: 400;
        line-height: 28px;
    }
}

.label {
    margin-top: 24px;
    border-radius: 12px;
    border: 1px solid $neutralsPlatinum;
    padding: 24px 16px;
    display: flex;
    flex-direction: column;
    text-align: start;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: $neutralsMoon;
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 32px;
        margin-bottom: 16px;
    }

    &.error {
        margin-top: 23px;
        border: 2px solid $raspberry;

        @media screen and (min-width: $above-tablet-length) {
            margin-top: 31px;
        }
    }

    span {
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px
    }

    .input {
        color: $charcoal;
        font-size: 15px;
        font-weight: 400;
        line-height: 20px;
        height: 20px;

        &::placeholder {
            color: $neutralsMoon;
            font-size: 17px;
            font-weight: 400;
            line-height: 24px
        }
    }

    .big-input {
        height: 24px;
    }
}

.little-label {
    padding: 18px 16px;
}

.error-message {
    margin-top: 8px;
    color: $white;
    background-color: $raspberry;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    padding: 4px 8px;
    width: fit-content;
    border-radius: 20px;
}

</style>
